$(document).ready(function() {
  //console.log('thematic-newsletter.js loaded');

  var floatedNewsletterForm = $('#floatedNewsletterForm');

  // Floated Newsletter Subscribe
  if (floatedNewsletterForm.length) {
    floatedNewsletterForm.validate({
      focusInvalid: true,
      errorClass: "error",
      messages: {
        thematic_nl_email: {
          required: 'Povinné pole',
          email: 'Zadejte emailovou adresu'
        },
      }
    })
  }

  floatedNewsletterForm.bind("invalid-form.validate", function () {
    $('.modal-wrapper').addClass('open');
    $('#thematic-newsletter-warning').addClass('active').closest('.modal-wrapper').addClass('open');

    const validator = floatedNewsletterForm.data('validator');
    if (validator) validator.settings.focusInvalid = false;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const btn = $('#thematic-newsletter-warning .js-modal-close').last()[0];
        if (btn) btn.focus();
      });
    });

  });

  $('#thematic-newsletter-warning').on('click', '.js-modal-close', function (e) {
    $("#thematicNlEmail").focus();
  })

  /* floatedNewsletter */
  if ($(".floatedNewsletter").length > 0) {

  /* open záložek v floatedNewsletter */
  document.body.addEventListener('click', toggleNewsletter);
  document.body.addEventListener('keydown', function(event) {
    // reaguje na Enter nebo Space
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.floatedNewsletter .js-toggle-content')) {
      event.preventDefault(); // zabrání scrollu při Space
      toggleNewsletter(event);
    }
  });

  function toggleNewsletter(event) {
    if (!event.target.matches('.floatedNewsletter .js-toggle-content')) return;

    const clickedElement = event.target.parentElement;
    const isAlreadyOpen = clickedElement.classList.contains('open');
    const allToggleElements = document.querySelectorAll('.floatedNewsletter .js-toggle-content');

    allToggleElements.forEach(function(toggleElement) {
      toggleElement.parentElement.classList.remove('open');
    });

    if (!isAlreadyOpen) {
      clickedElement.classList.add('open');
    }
  }

    /* plovoucí box, který se nabízí po přečtení  ⅔ obsahu anebo po 30% */
    window.addEventListener("scroll", function () {
      const floatedNewsletter = document.querySelector(".floatedNewsletter");

      if (floatedNewsletter && floatedNewsletter.classList.contains('d-none')) {
          let endChapters = document.getElementById("endchapters");

          if (!endChapters) {
              endChapters = document.querySelector(".article-content");
          }

          if (!endChapters) {
              return;
          }
          const rect = endChapters.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const targetPosition = windowHeight / 3; // 1/3 od vrchu okna

          if (rect.top <= targetPosition) {
              var isClosed = sessionStorage.getItem('floatedNewsletterClosed');

              if (isClosed === 'true') {
                  // prvek se nezobrazí, tento stav zůstane dokud neuzavřu okno nebo prohlížeč, potom se zobrazí znovu
                  return;
              } else {
                  floatedNewsletter.classList.remove('d-none');

                  // GA4 přes dataLayer (window.biTrackEvent, viz functions.php).
                  window.biTrackEvent('view_containerNL', {
                      bi_content_type: document.body.getAttribute('data-cpt'),
                      bi_newsletter_link: floatedNewsletter.getAttribute('data-link'),
                      bi_newsletter_type: floatedNewsletter.getAttribute('data-type'),
                  });
              }
          }
        }
    });


    if (floatedNewsletterForm.length > 0) {

      $('body').on('click', '.js-close-floated-newsletter', function (e) {
        e.preventDefault();
        e.stopPropagation();
        //$(this).closest('.floatedNewsletter').remove(); // remove element
        $(this).closest('.floatedNewsletter').addClass('d-none'); // hide element

        window.biTrackEvent('close_containerNL', {
          bi_content_type: $('body').data('cpt'),
          bi_newsletter_link: $('.floatedNewsletter').data('link'),
          bi_newsletter_type: $('.floatedNewsletter').data('type'),
        });

        sessionStorage.setItem('floatedNewsletterClosed', 'true');
      });
    }
  }

  /* Submit handler vždy, když existuje floatedNewsletterForm (i bez .floatedNewsletter, např. v pravém sloupci) */
  if (floatedNewsletterForm.length > 0) {
    $('body').on('submit', 'form#floatedNewsletterForm', function (e) {
      e.preventDefault();
      var form = $(this);
      if (!form.valid || !form.valid()) return;
      form.find('.js-nl-save-btn').addClass('is-loading');
      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
          var status = (data && data.status) ? data.status : 'error';
          $('.modal-wrapper').addClass('open');
          $('#thematic-newsletter-' + status).addClass('active').closest('.modal-wrapper').addClass('open');
          $('#thematic-newsletter-' + status).find('.js-modal-close').last().focus();

          $('#thematic-newsletter-error').on('click', '.js-modal-close', function (e) {
            $("#thematicNlEmail").focus();
          });

          if (status !== 'error') {
            var button = $('#floatedNewsletterForm input[type=submit], #floatedNewsletterForm button[type=submit]');
            button.addClass('success');
            button.html(`
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path id="check-circle-solid" d="M32,20A12,12,0,1,1,20,8,12,12,0,0,1,32,20ZM18.612,26.354l8.9-8.9a.774.774,0,0,0,0-1.095L26.42,15.261a.774.774,0,0,0-1.095,0l-7.261,7.261-3.39-3.39a.774.774,0,0,0-1.095,0l-1.095,1.095a.774.774,0,0,0,0,1.095l5.032,5.032a.774.774,0,0,0,1.095,0Z" transform="translate(-8 -8)" fill="#fff"/>
              </svg> OK
            `);
            if ($('.floatedNewsletter').length) {
              window.biTrackEvent('sent_containerNL', {
                bi_content_type: $('body').data('cpt'),
                bi_newsletter_link: $('.floatedNewsletter').data('link'),
                bi_newsletter_type: $('.floatedNewsletter').data('type'),
              });
            }
            sessionStorage.setItem('floatedNewsletterClosed', 'true');
            if ($('.floatedNewsletter').length) {
              $('.floatedNewsletter').addClass('d-none');
            }
            form[0].reset();
          }
        },
        error: function (xhr, status, err) {
          $('.modal-wrapper').addClass('open');
          $('#thematic-newsletter-error').addClass('active').closest('.modal-wrapper').addClass('open');
          $('#thematic-newsletter-error').find('.js-modal-close').last().focus();
          $('#thematic-newsletter-error').on('click', '.js-modal-close', function (e) {
            $("#thematicNlEmail").focus();
          });
        }
      }).always(function() {
        form.find('.js-nl-save-btn').removeClass('is-loading');
      });
    });
  }

});
